export default __webpack_public_path__ + "static/media/Mock1.cb8119c9.png";